 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"gpi-lbl-app-feature-shell":"gpi-lbl-app-feature-shell","gpi-lbl-app-feature-auth":"gpi-lbl-app-feature-auth","gpi-lbl-app-feature-private":"gpi-lbl-app-feature-private","common":"common","gpi-lbl-app-feature-chiosco":"gpi-lbl-app-feature-chiosco","gpi-lbl-app-feature-backoffice":"gpi-lbl-app-feature-backoffice","default~gpi-lbl-app-feature-gestione-pasti-giornalieri~gpi-lbl-app-feature-menu":"default~gpi-lbl-app-feature-gestione-pasti-giornalieri~gpi-lbl-app-feature-menu","gpi-lbl-app-feature-menu":"gpi-lbl-app-feature-menu","gpi-lbl-app-feature-bambini":"gpi-lbl-app-feature-bambini","gpi-lbl-app-feature-identita-struttura":"gpi-lbl-app-feature-identita-struttura","gpi-lbl-app-feature-il-mio-profilo":"gpi-lbl-app-feature-il-mio-profilo","gpi-lbl-app-feature-incontri-sezione":"gpi-lbl-app-feature-incontri-sezione","gpi-lbl-app-feature-news-eventi":"gpi-lbl-app-feature-news-eventi","gpi-lbl-app-feature-notifiche":"gpi-lbl-app-feature-notifiche","gpi-lbl-app-feature-portfolio-competenze":"gpi-lbl-app-feature-portfolio-competenze","gpi-lbl-app-feature-progetto":"gpi-lbl-app-feature-progetto","gpi-lbl-app-feature-quotidianita":"gpi-lbl-app-feature-quotidianita","gpi-lbl-app-feature-strumenti-lbl":"gpi-lbl-app-feature-strumenti-lbl","gpi-lbl-app-feature-gestione-anagrafiche":"gpi-lbl-app-feature-gestione-anagrafiche","gpi-lbl-app-feature-gestione-contenuti-chiosco":"gpi-lbl-app-feature-gestione-contenuti-chiosco","gpi-lbl-app-feature-gestione-menu-mensa":"gpi-lbl-app-feature-gestione-menu-mensa","gpi-lbl-app-feature-gestione-strutture-educative":"gpi-lbl-app-feature-gestione-strutture-educative","gpi-lbl-app-feature-gestione-utenti":"gpi-lbl-app-feature-gestione-utenti","gpi-lbl-app-feature-gestione-pasti-giornalieri":"gpi-lbl-app-feature-gestione-pasti-giornalieri","gpi-lbl-app-feature-archivio-strumenti-registrazione":"gpi-lbl-app-feature-archivio-strumenti-registrazione","gpi-lbl-app-feature-gestione-anni-scolastici":"gpi-lbl-app-feature-gestione-anni-scolastici","gpi-lbl-app-feature-help":"gpi-lbl-app-feature-help","gpi-lbl-app-feature-strumenti-modulo-gestionale":"gpi-lbl-app-feature-strumenti-modulo-gestionale","gpi-lbl-app-feature-strumenti-modulo-monitoring":"gpi-lbl-app-feature-strumenti-modulo-monitoring","gpi-lbl-app-feature-strumenti-modulo-valutazione":"gpi-lbl-app-feature-strumenti-modulo-valutazione","gpi-lbl-app-feature-istogramma-competenze-individuali-campi-esperienza":"gpi-lbl-app-feature-istogramma-competenze-individuali-campi-esperienza","gpi-lbl-app-feature-gestione-portfolio-competenze-bambini":"gpi-lbl-app-feature-gestione-portfolio-competenze-bambini","gpi-lbl-app-feature-strumenti-valutazione-competenze-bambini":"gpi-lbl-app-feature-strumenti-valutazione-competenze-bambini","gpi-lbl-app-feature-dicci-cosa-pensi-di-noi":"gpi-lbl-app-feature-dicci-cosa-pensi-di-noi","gpi-lbl-app-feature-pensieri-riflessioni":"gpi-lbl-app-feature-pensieri-riflessioni","gpi-lbl-app-feature-racconti-riflessioni":"gpi-lbl-app-feature-racconti-riflessioni","gpi-lbl-app-feature-strumenti-ambientamento-accoglienza-bambino":"gpi-lbl-app-feature-strumenti-ambientamento-accoglienza-bambino","gpi-lbl-app-feature-strumenti-comunicazione-quotidiana":"gpi-lbl-app-feature-strumenti-comunicazione-quotidiana","gpi-lbl-app-feature-strumenti-monitoraggio-valutazione":"gpi-lbl-app-feature-strumenti-monitoraggio-valutazione","gpi-lbl-app-feature-strumenti-progettazione":"gpi-lbl-app-feature-strumenti-progettazione","gpi-lbl-app-feature-calcolo-lbl-compliance":"gpi-lbl-app-feature-calcolo-lbl-compliance","gpi-lbl-app-feature-gestione-matrice-indicatori":"gpi-lbl-app-feature-gestione-matrice-indicatori","gpi-lbl-app-feature-export-relazione-auditing":"gpi-lbl-app-feature-export-relazione-auditing","gpi-lbl-app-feature-gestione-customer-care":"gpi-lbl-app-feature-gestione-customer-care","gpi-lbl-app-feature-gestione-foglio-sintesi-valutazione":"gpi-lbl-app-feature-gestione-foglio-sintesi-valutazione","gpi-lbl-app-feature-gestione-osservazioni-linguaggi-espressivi-creativita":"gpi-lbl-app-feature-gestione-osservazioni-linguaggi-espressivi-creativita","gpi-lbl-app-feature-gestione-valutazione-ambiti-sviluppo-competenze-individuali":"gpi-lbl-app-feature-gestione-valutazione-ambiti-sviluppo-competenze-individuali","gpi-lbl-app-feature-gestione-colloqui-iniziali":"gpi-lbl-app-feature-gestione-colloqui-iniziali","gpi-lbl-app-feature-gestione-osservazione-primi-giorni-ambientamento":"gpi-lbl-app-feature-gestione-osservazione-primi-giorni-ambientamento","gpi-lbl-app-feature-visualizzazione-racconti-pensieri-riflessioni-parenti-bambino":"gpi-lbl-app-feature-visualizzazione-racconti-pensieri-riflessioni-parenti-bambino","gpi-lbl-app-feature-gestione-situazioni-giornaliere":"gpi-lbl-app-feature-gestione-situazioni-giornaliere","gpi-lbl-app-feature-competenze-insegnanti":"gpi-lbl-app-feature-competenze-insegnanti","gpi-lbl-app-feature-gestione-rilevazioni":"gpi-lbl-app-feature-gestione-rilevazioni","gpi-lbl-app-feature-gestione-scheda-autovalutazione-qualita":"gpi-lbl-app-feature-gestione-scheda-autovalutazione-qualita","gpi-lbl-app-feature-gestione-scheda-controllo-pulizie":"gpi-lbl-app-feature-gestione-scheda-controllo-pulizie","gpi-lbl-app-feature-registrazioni-cadute-incidenti-bambini":"gpi-lbl-app-feature-registrazioni-cadute-incidenti-bambini","gpi-lbl-app-feature-registrazioni-smarrimento-oggetti-bambino":"gpi-lbl-app-feature-registrazioni-smarrimento-oggetti-bambino","gpi-lbl-app-feature-ricaduta-attivita-formativa":"gpi-lbl-app-feature-ricaduta-attivita-formativa","gpi-lbl-app-feature-scheda-autovalutazione-qualita-sintesi-livello-struttura":"gpi-lbl-app-feature-scheda-autovalutazione-qualita-sintesi-livello-struttura","gpi-lbl-app-feature-gestione-progettazioni-settimanali":"gpi-lbl-app-feature-gestione-progettazioni-settimanali","gpi-lbl-app-feature-gestione-scritture-progettuali":"gpi-lbl-app-feature-gestione-scritture-progettuali","gpi-lbl-app-feature-gestione-sipi":"gpi-lbl-app-feature-gestione-sipi","gpi-lbl-app-feature-validazione-scritture-progettuali":"gpi-lbl-app-feature-validazione-scritture-progettuali","gpi-lbl-app-feature-verbale-valutazione-verifica":"gpi-lbl-app-feature-verbale-valutazione-verifica","canvg":"canvg","dompurify":"dompurify","gpi-lbl-app-feature-erogazione-servizio":"gpi-lbl-app-feature-erogazione-servizio","gpi-lbl-app-feature-family-engagement":"gpi-lbl-app-feature-family-engagement","gpi-lbl-app-feature-implementazione-curricolo":"gpi-lbl-app-feature-implementazione-curricolo","gpi-lbl-app-feature-relazione-sintesi":"gpi-lbl-app-feature-relazione-sintesi","gpi-lbl-app-feature-standard-strutturali-organizzativi":"gpi-lbl-app-feature-standard-strutturali-organizzativi","gpi-lbl-app-feature-valutazione-efficacia-outcomes-servizio":"gpi-lbl-app-feature-valutazione-efficacia-outcomes-servizio","gpi-lbl-app-feature-rilevazione-allestimento-spazi-ricerche-materiali-aree-esterne":"gpi-lbl-app-feature-rilevazione-allestimento-spazi-ricerche-materiali-aree-esterne","gpi-lbl-app-feature-rilevazione-allestimento-spazi-ricerche-materiali-servizi-educativi":"gpi-lbl-app-feature-rilevazione-allestimento-spazi-ricerche-materiali-servizi-educativi","gpi-lbl-app-feature-rilevazione-documentazione-progettuale-realizzatai-servizi-educativi":"gpi-lbl-app-feature-rilevazione-documentazione-progettuale-realizzatai-servizi-educativi","gpi-lbl-app-feature-rilevazione-partecipazione-famiglie":"gpi-lbl-app-feature-rilevazione-partecipazione-famiglie","gpi-lbl-app-feature-rilevazione-progettazioni-attivita-linguaggi-cibo":"gpi-lbl-app-feature-rilevazione-progettazioni-attivita-linguaggi-cibo","gpi-lbl-app-feature-rilevazione-progettazioni-attivita-sviluppo-pensiero-ecologico":"gpi-lbl-app-feature-rilevazione-progettazioni-attivita-sviluppo-pensiero-ecologico","gpi-lbl-app-feature-rilevazione-progettualita-sviluppo-linguaggi-espressivi-creativita":"gpi-lbl-app-feature-rilevazione-progettualita-sviluppo-linguaggi-espressivi-creativita","gpi-lbl-app-feature-rilevazione-promozione-progettazione-ambiti-sviluppo-campi-esperienza":"gpi-lbl-app-feature-rilevazione-promozione-progettazione-ambiti-sviluppo-campi-esperienza","gpi-lbl-app-feature-sipi-sezione-anagrafica":"gpi-lbl-app-feature-sipi-sezione-anagrafica","gpi-lbl-app-feature-sipi-sezione-raccolta-informazioni":"gpi-lbl-app-feature-sipi-sezione-raccolta-informazioni","gpi-lbl-app-feature-sipi-sezione-sintesi-progetto":"gpi-lbl-app-feature-sipi-sezione-sintesi-progetto","gpi-lbl-app-feature-sipi-sezione-situazione-iniziale":"gpi-lbl-app-feature-sipi-sezione-situazione-iniziale","gpi-lbl-app-feature-sipi-sezione-strumento-progettuale":"gpi-lbl-app-feature-sipi-sezione-strumento-progettuale","gpi-lbl-app-feature-sipi-sezione-verbali":"gpi-lbl-app-feature-sipi-sezione-verbali"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
